/*
 * bpmbuild-development.appspot.com
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 2.4.11-SNAPSHOT
 *
 * Do not edit the class manually.
 *
 */

(function(factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/AnswerBean', 'model/AttributeBean', 'model/AttributeRequest', 'model/AttributeResponse', 'model/AttributeSetBean', 'model/AttributeSetRequest', 'model/AttributeSetResponse', 'model/Axis', 'model/BuildingBean', 'model/BuildingResponse', 'model/BuildingV2Request', 'model/BuildingV2Response', 'model/BusinessBean', 'model/BusinessRequest', 'model/BusinessResponse', 'model/CatalogueBean', 'model/CatalogueRequest', 'model/CatalogueResponse', 'model/CategoryBean', 'model/CategoryRequest', 'model/CategoryResponse', 'model/ChartArea', 'model/ChartBean', 'model/ChartColumnBean', 'model/ChartDataBean', 'model/Choice', 'model/Choices', 'model/ConfigurationRequest', 'model/ConfigurationResponse', 'model/DefinitionBean', 'model/DeliveryItemV2Request', 'model/DeliveryItemV2Response', 'model/DeliveryV2Request', 'model/DeliveryV2Response', 'model/FieldsBean', 'model/FlowBean', 'model/FlowItemBean', 'model/FlowItemRequest', 'model/FlowItemResponse', 'model/FlowRequest', 'model/FlowResponse', 'model/FormResponseBean', 'model/GenericBean', 'model/GoogleChartOptionsBean', 'model/GoogleChartOptionsRequest', 'model/GoogleChartOptionsResponse', 'model/IBuildingV2Response', 'model/IInvoiceItemV2Bean', 'model/IInvoiceItemV2Response', 'model/IKanbanBoard', 'model/ILocationV2Response', 'model/ISiteV2Response', 'model/IStatisticsBean', 'model/IStatisticsResponse', 'model/IStripeAccountBean', 'model/IStripeCustomerBean', 'model/InvoiceItemV2Request', 'model/InvoiceItemV2Response', 'model/InvoiceV2Request', 'model/InvoiceV2Response', 'model/KanbanBoard', 'model/KanbanCard', 'model/KanbanColumn', 'model/KanbanStyle', 'model/KanbanSwimLane', 'model/LocationBean', 'model/LocationResponse', 'model/LocationV2Request', 'model/LocationV2Response', 'model/LoginRequest', 'model/LoginResponse', 'model/MetaData', 'model/OrderItemV2Request', 'model/OrderItemV2Response', 'model/OrderV2Request', 'model/OrderV2Response', 'model/PartBean', 'model/PartRequest', 'model/PartResponse', 'model/ProductBean', 'model/ProductRequest', 'model/ProductResponse', 'model/PublisherBean', 'model/PublisherRequest', 'model/PublisherResponse', 'model/SettingsBean', 'model/SettingsRequest', 'model/SettingsResponse', 'model/SiteBean', 'model/SiteResponse', 'model/SiteV2Request', 'model/SiteV2Response', 'model/StationBean', 'model/StationRequest', 'model/StationResponse', 'model/StatisticsRequest', 'model/StatisticsResponse', 'model/StripeAccountBean', 'model/StripeAccountEventBean', 'model/StripeAccountEventObject', 'model/StripeAccountEventRequest', 'model/StripeAccountMetadataBean', 'model/StripeAccountRequest', 'model/StripeAccountResponse', 'model/StripeCouponBean', 'model/StripeCustomerBean', 'model/StripeCustomerEventBean', 'model/StripeCustomerEventObject', 'model/StripeCustomerEventRequest', 'model/StripeCustomerMetadataBean', 'model/StripeCustomerRequest', 'model/StripeCustomerResponse', 'model/StripeDiscountBean', 'model/StripePlanBean', 'model/StripeSubscriptionBean', 'model/StripeSubscriptionEventBean', 'model/StripeSubscriptionEventObject', 'model/StripeSubscriptionEventRequest', 'model/StripeSubscriptionItemBean', 'model/StripeSubscriptionItemMetadataBean', 'model/StripeSubscriptionRequest', 'model/StripeSubscriptionResponse', 'model/StripeTaxIdBean', 'model/StripeTaxRateBean', 'model/SubscriberBean', 'model/SubscriberRequest', 'model/SubscriberResponse', 'model/SubscriptionMetadataBean', 'model/TopicBean', 'model/TopicRequest', 'model/TopicResponse', 'model/TypeformBean', 'model/TypeformRequest', 'model/TypeformResponse', 'model/UserBean', 'model/UserRequest', 'model/UserResponse', 'model/WorkItemV2Request', 'model/WorkItemV2Response', 'model/WorkV2Request', 'model/WorkV2Response', 'api/DefaultApi'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('./ApiClient'), require('./model/AnswerBean'), require('./model/AttributeBean'), require('./model/AttributeRequest'), require('./model/AttributeResponse'), require('./model/AttributeSetBean'), require('./model/AttributeSetRequest'), require('./model/AttributeSetResponse'), require('./model/Axis'), require('./model/BuildingBean'), require('./model/BuildingResponse'), require('./model/BuildingV2Request'), require('./model/BuildingV2Response'), require('./model/BusinessBean'), require('./model/BusinessRequest'), require('./model/BusinessResponse'), require('./model/CatalogueBean'), require('./model/CatalogueRequest'), require('./model/CatalogueResponse'), require('./model/CategoryBean'), require('./model/CategoryRequest'), require('./model/CategoryResponse'), require('./model/ChartArea'), require('./model/ChartBean'), require('./model/ChartColumnBean'), require('./model/ChartDataBean'), require('./model/Choice'), require('./model/Choices'), require('./model/ConfigurationRequest'), require('./model/ConfigurationResponse'), require('./model/DefinitionBean'), require('./model/DeliveryItemV2Request'), require('./model/DeliveryItemV2Response'), require('./model/DeliveryV2Request'), require('./model/DeliveryV2Response'), require('./model/FieldsBean'), require('./model/FlowBean'), require('./model/FlowItemBean'), require('./model/FlowItemRequest'), require('./model/FlowItemResponse'), require('./model/FlowRequest'), require('./model/FlowResponse'), require('./model/FormResponseBean'), require('./model/GenericBean'), require('./model/GoogleChartOptionsBean'), require('./model/GoogleChartOptionsRequest'), require('./model/GoogleChartOptionsResponse'), require('./model/IBuildingV2Response'), require('./model/IInvoiceItemV2Bean'), require('./model/IInvoiceItemV2Response'), require('./model/IKanbanBoard'), require('./model/ILocationV2Response'), require('./model/ISiteV2Response'), require('./model/IStatisticsBean'), require('./model/IStatisticsResponse'), require('./model/IStripeAccountBean'), require('./model/IStripeCustomerBean'), require('./model/InvoiceItemV2Request'), require('./model/InvoiceItemV2Response'), require('./model/InvoiceV2Request'), require('./model/InvoiceV2Response'), require('./model/KanbanBoard'), require('./model/KanbanCard'), require('./model/KanbanColumn'), require('./model/KanbanStyle'), require('./model/KanbanSwimLane'), require('./model/LocationBean'), require('./model/LocationResponse'), require('./model/LocationV2Request'), require('./model/LocationV2Response'), require('./model/LoginRequest'), require('./model/LoginResponse'), require('./model/MetaData'), require('./model/OrderItemV2Request'), require('./model/OrderItemV2Response'), require('./model/OrderV2Request'), require('./model/OrderV2Response'), require('./model/PartBean'), require('./model/PartRequest'), require('./model/PartResponse'), require('./model/ProductBean'), require('./model/ProductRequest'), require('./model/ProductResponse'), require('./model/PublisherBean'), require('./model/PublisherRequest'), require('./model/PublisherResponse'), require('./model/SettingsBean'), require('./model/SettingsRequest'), require('./model/SettingsResponse'), require('./model/SiteBean'), require('./model/SiteResponse'), require('./model/SiteV2Request'), require('./model/SiteV2Response'), require('./model/StationBean'), require('./model/StationRequest'), require('./model/StationResponse'), require('./model/StatisticsRequest'), require('./model/StatisticsResponse'), require('./model/StripeAccountBean'), require('./model/StripeAccountEventBean'), require('./model/StripeAccountEventObject'), require('./model/StripeAccountEventRequest'), require('./model/StripeAccountMetadataBean'), require('./model/StripeAccountRequest'), require('./model/StripeAccountResponse'), require('./model/StripeCouponBean'), require('./model/StripeCustomerBean'), require('./model/StripeCustomerEventBean'), require('./model/StripeCustomerEventObject'), require('./model/StripeCustomerEventRequest'), require('./model/StripeCustomerMetadataBean'), require('./model/StripeCustomerRequest'), require('./model/StripeCustomerResponse'), require('./model/StripeDiscountBean'), require('./model/StripePlanBean'), require('./model/StripeSubscriptionBean'), require('./model/StripeSubscriptionEventBean'), require('./model/StripeSubscriptionEventObject'), require('./model/StripeSubscriptionEventRequest'), require('./model/StripeSubscriptionItemBean'), require('./model/StripeSubscriptionItemMetadataBean'), require('./model/StripeSubscriptionRequest'), require('./model/StripeSubscriptionResponse'), require('./model/StripeTaxIdBean'), require('./model/StripeTaxRateBean'), require('./model/SubscriberBean'), require('./model/SubscriberRequest'), require('./model/SubscriberResponse'), require('./model/SubscriptionMetadataBean'), require('./model/TopicBean'), require('./model/TopicRequest'), require('./model/TopicResponse'), require('./model/TypeformBean'), require('./model/TypeformRequest'), require('./model/TypeformResponse'), require('./model/UserBean'), require('./model/UserRequest'), require('./model/UserResponse'), require('./model/WorkItemV2Request'), require('./model/WorkItemV2Response'), require('./model/WorkV2Request'), require('./model/WorkV2Response'), require('./api/DefaultApi'));
  }
}(function(ApiClient, AnswerBean, AttributeBean, AttributeRequest, AttributeResponse, AttributeSetBean, AttributeSetRequest, AttributeSetResponse, Axis, BuildingBean, BuildingResponse, BuildingV2Request, BuildingV2Response, BusinessBean, BusinessRequest, BusinessResponse, CatalogueBean, CatalogueRequest, CatalogueResponse, CategoryBean, CategoryRequest, CategoryResponse, ChartArea, ChartBean, ChartColumnBean, ChartDataBean, Choice, Choices, ConfigurationRequest, ConfigurationResponse, DefinitionBean, DeliveryItemV2Request, DeliveryItemV2Response, DeliveryV2Request, DeliveryV2Response, FieldsBean, FlowBean, FlowItemBean, FlowItemRequest, FlowItemResponse, FlowRequest, FlowResponse, FormResponseBean, GenericBean, GoogleChartOptionsBean, GoogleChartOptionsRequest, GoogleChartOptionsResponse, IBuildingV2Response, IInvoiceItemV2Bean, IInvoiceItemV2Response, IKanbanBoard, ILocationV2Response, ISiteV2Response, IStatisticsBean, IStatisticsResponse, IStripeAccountBean, IStripeCustomerBean, InvoiceItemV2Request, InvoiceItemV2Response, InvoiceV2Request, InvoiceV2Response, KanbanBoard, KanbanCard, KanbanColumn, KanbanStyle, KanbanSwimLane, LocationBean, LocationResponse, LocationV2Request, LocationV2Response, LoginRequest, LoginResponse, MetaData, OrderItemV2Request, OrderItemV2Response, OrderV2Request, OrderV2Response, PartBean, PartRequest, PartResponse, ProductBean, ProductRequest, ProductResponse, PublisherBean, PublisherRequest, PublisherResponse, SettingsBean, SettingsRequest, SettingsResponse, SiteBean, SiteResponse, SiteV2Request, SiteV2Response, StationBean, StationRequest, StationResponse, StatisticsRequest, StatisticsResponse, StripeAccountBean, StripeAccountEventBean, StripeAccountEventObject, StripeAccountEventRequest, StripeAccountMetadataBean, StripeAccountRequest, StripeAccountResponse, StripeCouponBean, StripeCustomerBean, StripeCustomerEventBean, StripeCustomerEventObject, StripeCustomerEventRequest, StripeCustomerMetadataBean, StripeCustomerRequest, StripeCustomerResponse, StripeDiscountBean, StripePlanBean, StripeSubscriptionBean, StripeSubscriptionEventBean, StripeSubscriptionEventObject, StripeSubscriptionEventRequest, StripeSubscriptionItemBean, StripeSubscriptionItemMetadataBean, StripeSubscriptionRequest, StripeSubscriptionResponse, StripeTaxIdBean, StripeTaxRateBean, SubscriberBean, SubscriberRequest, SubscriberResponse, SubscriptionMetadataBean, TopicBean, TopicRequest, TopicResponse, TypeformBean, TypeformRequest, TypeformResponse, UserBean, UserRequest, UserResponse, WorkItemV2Request, WorkItemV2Response, WorkV2Request, WorkV2Response, DefaultApi) {
  'use strict';

  /**
   * ERROR_UNKNOWN.<br>
   * The <code>index</code> module provides access to constructors for all the classes which comprise the public API.
   * <p>
   * An AMD (recommended!) or CommonJS application will generally do something equivalent to the following:
   * <pre>
   * var BpmbuildDevelopmentappspotcom = require('index'); // See note below*.
   * var xxxSvc = new BpmbuildDevelopmentappspotcom.XxxApi(); // Allocate the API class we're going to use.
   * var yyyModel = new BpmbuildDevelopmentappspotcom.Yyy(); // Construct a model instance.
   * yyyModel.someProperty = 'someValue';
   * ...
   * var zzz = xxxSvc.doSomething(yyyModel); // Invoke the service.
   * ...
   * </pre>
   * <em>*NOTE: For a top-level AMD script, use require(['index'], function(){...})
   * and put the application logic within the callback function.</em>
   * </p>
   * <p>
   * A non-AMD browser application (discouraged) might do something like this:
   * <pre>
   * var xxxSvc = new BpmbuildDevelopmentappspotcom.XxxApi(); // Allocate the API class we're going to use.
   * var yyy = new BpmbuildDevelopmentappspotcom.Yyy(); // Construct a model instance.
   * yyyModel.someProperty = 'someValue';
   * ...
   * var zzz = xxxSvc.doSomething(yyyModel); // Invoke the service.
   * ...
   * </pre>
   * </p>
   * @module index
   * @version 1.0.0
   */
  var exports = {
    /**
     * The ApiClient constructor.
     * @property {module:ApiClient}
     */
    ApiClient: ApiClient,
    /**
     * The AnswerBean model constructor.
     * @property {module:model/AnswerBean}
     */
    AnswerBean: AnswerBean,
    /**
     * The AttributeBean model constructor.
     * @property {module:model/AttributeBean}
     */
    AttributeBean: AttributeBean,
    /**
     * The AttributeRequest model constructor.
     * @property {module:model/AttributeRequest}
     */
    AttributeRequest: AttributeRequest,
    /**
     * The AttributeResponse model constructor.
     * @property {module:model/AttributeResponse}
     */
    AttributeResponse: AttributeResponse,
    /**
     * The AttributeSetBean model constructor.
     * @property {module:model/AttributeSetBean}
     */
    AttributeSetBean: AttributeSetBean,
    /**
     * The AttributeSetRequest model constructor.
     * @property {module:model/AttributeSetRequest}
     */
    AttributeSetRequest: AttributeSetRequest,
    /**
     * The AttributeSetResponse model constructor.
     * @property {module:model/AttributeSetResponse}
     */
    AttributeSetResponse: AttributeSetResponse,
    /**
     * The Axis model constructor.
     * @property {module:model/Axis}
     */
    Axis: Axis,
    /**
     * The BuildingBean model constructor.
     * @property {module:model/BuildingBean}
     */
    BuildingBean: BuildingBean,
    /**
     * The BuildingResponse model constructor.
     * @property {module:model/BuildingResponse}
     */
    BuildingResponse: BuildingResponse,
    /**
     * The BuildingV2Request model constructor.
     * @property {module:model/BuildingV2Request}
     */
    BuildingV2Request: BuildingV2Request,
    /**
     * The BuildingV2Response model constructor.
     * @property {module:model/BuildingV2Response}
     */
    BuildingV2Response: BuildingV2Response,
    /**
     * The BusinessBean model constructor.
     * @property {module:model/BusinessBean}
     */
    BusinessBean: BusinessBean,
    /**
     * The BusinessRequest model constructor.
     * @property {module:model/BusinessRequest}
     */
    BusinessRequest: BusinessRequest,
    /**
     * The BusinessResponse model constructor.
     * @property {module:model/BusinessResponse}
     */
    BusinessResponse: BusinessResponse,
    /**
     * The CatalogueBean model constructor.
     * @property {module:model/CatalogueBean}
     */
    CatalogueBean: CatalogueBean,
    /**
     * The CatalogueRequest model constructor.
     * @property {module:model/CatalogueRequest}
     */
    CatalogueRequest: CatalogueRequest,
    /**
     * The CatalogueResponse model constructor.
     * @property {module:model/CatalogueResponse}
     */
    CatalogueResponse: CatalogueResponse,
    /**
     * The CategoryBean model constructor.
     * @property {module:model/CategoryBean}
     */
    CategoryBean: CategoryBean,
    /**
     * The CategoryRequest model constructor.
     * @property {module:model/CategoryRequest}
     */
    CategoryRequest: CategoryRequest,
    /**
     * The CategoryResponse model constructor.
     * @property {module:model/CategoryResponse}
     */
    CategoryResponse: CategoryResponse,
    /**
     * The ChartArea model constructor.
     * @property {module:model/ChartArea}
     */
    ChartArea: ChartArea,
    /**
     * The ChartBean model constructor.
     * @property {module:model/ChartBean}
     */
    ChartBean: ChartBean,
    /**
     * The ChartColumnBean model constructor.
     * @property {module:model/ChartColumnBean}
     */
    ChartColumnBean: ChartColumnBean,
    /**
     * The ChartDataBean model constructor.
     * @property {module:model/ChartDataBean}
     */
    ChartDataBean: ChartDataBean,
    /**
     * The Choice model constructor.
     * @property {module:model/Choice}
     */
    Choice: Choice,
    /**
     * The Choices model constructor.
     * @property {module:model/Choices}
     */
    Choices: Choices,
    /**
     * The ConfigurationRequest model constructor.
     * @property {module:model/ConfigurationRequest}
     */
    ConfigurationRequest: ConfigurationRequest,
    /**
     * The ConfigurationResponse model constructor.
     * @property {module:model/ConfigurationResponse}
     */
    ConfigurationResponse: ConfigurationResponse,
    /**
     * The DefinitionBean model constructor.
     * @property {module:model/DefinitionBean}
     */
    DefinitionBean: DefinitionBean,
    /**
     * The DeliveryItemV2Request model constructor.
     * @property {module:model/DeliveryItemV2Request}
     */
    DeliveryItemV2Request: DeliveryItemV2Request,
    /**
     * The DeliveryItemV2Response model constructor.
     * @property {module:model/DeliveryItemV2Response}
     */
    DeliveryItemV2Response: DeliveryItemV2Response,
    /**
     * The DeliveryV2Request model constructor.
     * @property {module:model/DeliveryV2Request}
     */
    DeliveryV2Request: DeliveryV2Request,
    /**
     * The DeliveryV2Response model constructor.
     * @property {module:model/DeliveryV2Response}
     */
    DeliveryV2Response: DeliveryV2Response,
    /**
     * The FieldsBean model constructor.
     * @property {module:model/FieldsBean}
     */
    FieldsBean: FieldsBean,
    /**
     * The FlowBean model constructor.
     * @property {module:model/FlowBean}
     */
    FlowBean: FlowBean,
    /**
     * The FlowItemBean model constructor.
     * @property {module:model/FlowItemBean}
     */
    FlowItemBean: FlowItemBean,
    /**
     * The FlowItemRequest model constructor.
     * @property {module:model/FlowItemRequest}
     */
    FlowItemRequest: FlowItemRequest,
    /**
     * The FlowItemResponse model constructor.
     * @property {module:model/FlowItemResponse}
     */
    FlowItemResponse: FlowItemResponse,
    /**
     * The FlowRequest model constructor.
     * @property {module:model/FlowRequest}
     */
    FlowRequest: FlowRequest,
    /**
     * The FlowResponse model constructor.
     * @property {module:model/FlowResponse}
     */
    FlowResponse: FlowResponse,
    /**
     * The FormResponseBean model constructor.
     * @property {module:model/FormResponseBean}
     */
    FormResponseBean: FormResponseBean,
    /**
     * The GenericBean model constructor.
     * @property {module:model/GenericBean}
     */
    GenericBean: GenericBean,
    /**
     * The GoogleChartOptionsBean model constructor.
     * @property {module:model/GoogleChartOptionsBean}
     */
    GoogleChartOptionsBean: GoogleChartOptionsBean,
    /**
     * The GoogleChartOptionsRequest model constructor.
     * @property {module:model/GoogleChartOptionsRequest}
     */
    GoogleChartOptionsRequest: GoogleChartOptionsRequest,
    /**
     * The GoogleChartOptionsResponse model constructor.
     * @property {module:model/GoogleChartOptionsResponse}
     */
    GoogleChartOptionsResponse: GoogleChartOptionsResponse,
    /**
     * The IBuildingV2Response model constructor.
     * @property {module:model/IBuildingV2Response}
     */
    IBuildingV2Response: IBuildingV2Response,
    /**
     * The IInvoiceItemV2Bean model constructor.
     * @property {module:model/IInvoiceItemV2Bean}
     */
    IInvoiceItemV2Bean: IInvoiceItemV2Bean,
    /**
     * The IInvoiceItemV2Response model constructor.
     * @property {module:model/IInvoiceItemV2Response}
     */
    IInvoiceItemV2Response: IInvoiceItemV2Response,
    /**
     * The IKanbanBoard model constructor.
     * @property {module:model/IKanbanBoard}
     */
    IKanbanBoard: IKanbanBoard,
    /**
     * The ILocationV2Response model constructor.
     * @property {module:model/ILocationV2Response}
     */
    ILocationV2Response: ILocationV2Response,
    /**
     * The ISiteV2Response model constructor.
     * @property {module:model/ISiteV2Response}
     */
    ISiteV2Response: ISiteV2Response,
    /**
     * The IStatisticsBean model constructor.
     * @property {module:model/IStatisticsBean}
     */
    IStatisticsBean: IStatisticsBean,
    /**
     * The IStatisticsResponse model constructor.
     * @property {module:model/IStatisticsResponse}
     */
    IStatisticsResponse: IStatisticsResponse,
    /**
     * The IStripeAccountBean model constructor.
     * @property {module:model/IStripeAccountBean}
     */
    IStripeAccountBean: IStripeAccountBean,
    /**
     * The IStripeCustomerBean model constructor.
     * @property {module:model/IStripeCustomerBean}
     */
    IStripeCustomerBean: IStripeCustomerBean,
    /**
     * The InvoiceItemV2Request model constructor.
     * @property {module:model/InvoiceItemV2Request}
     */
    InvoiceItemV2Request: InvoiceItemV2Request,
    /**
     * The InvoiceItemV2Response model constructor.
     * @property {module:model/InvoiceItemV2Response}
     */
    InvoiceItemV2Response: InvoiceItemV2Response,
    /**
     * The InvoiceV2Request model constructor.
     * @property {module:model/InvoiceV2Request}
     */
    InvoiceV2Request: InvoiceV2Request,
    /**
     * The InvoiceV2Response model constructor.
     * @property {module:model/InvoiceV2Response}
     */
    InvoiceV2Response: InvoiceV2Response,
    /**
     * The KanbanBoard model constructor.
     * @property {module:model/KanbanBoard}
     */
    KanbanBoard: KanbanBoard,
    /**
     * The KanbanCard model constructor.
     * @property {module:model/KanbanCard}
     */
    KanbanCard: KanbanCard,
    /**
     * The KanbanColumn model constructor.
     * @property {module:model/KanbanColumn}
     */
    KanbanColumn: KanbanColumn,
    /**
     * The KanbanStyle model constructor.
     * @property {module:model/KanbanStyle}
     */
    KanbanStyle: KanbanStyle,
    /**
     * The KanbanSwimLane model constructor.
     * @property {module:model/KanbanSwimLane}
     */
    KanbanSwimLane: KanbanSwimLane,
    /**
     * The LocationBean model constructor.
     * @property {module:model/LocationBean}
     */
    LocationBean: LocationBean,
    /**
     * The LocationResponse model constructor.
     * @property {module:model/LocationResponse}
     */
    LocationResponse: LocationResponse,
    /**
     * The LocationV2Request model constructor.
     * @property {module:model/LocationV2Request}
     */
    LocationV2Request: LocationV2Request,
    /**
     * The LocationV2Response model constructor.
     * @property {module:model/LocationV2Response}
     */
    LocationV2Response: LocationV2Response,
    /**
     * The LoginRequest model constructor.
     * @property {module:model/LoginRequest}
     */
    LoginRequest: LoginRequest,
    /**
     * The LoginResponse model constructor.
     * @property {module:model/LoginResponse}
     */
    LoginResponse: LoginResponse,
    /**
     * The MetaData model constructor.
     * @property {module:model/MetaData}
     */
    MetaData: MetaData,
    /**
     * The OrderItemV2Request model constructor.
     * @property {module:model/OrderItemV2Request}
     */
    OrderItemV2Request: OrderItemV2Request,
    /**
     * The OrderItemV2Response model constructor.
     * @property {module:model/OrderItemV2Response}
     */
    OrderItemV2Response: OrderItemV2Response,
    /**
     * The OrderV2Request model constructor.
     * @property {module:model/OrderV2Request}
     */
    OrderV2Request: OrderV2Request,
    /**
     * The OrderV2Response model constructor.
     * @property {module:model/OrderV2Response}
     */
    OrderV2Response: OrderV2Response,
    /**
     * The PartBean model constructor.
     * @property {module:model/PartBean}
     */
    PartBean: PartBean,
    /**
     * The PartRequest model constructor.
     * @property {module:model/PartRequest}
     */
    PartRequest: PartRequest,
    /**
     * The PartResponse model constructor.
     * @property {module:model/PartResponse}
     */
    PartResponse: PartResponse,
    /**
     * The ProductBean model constructor.
     * @property {module:model/ProductBean}
     */
    ProductBean: ProductBean,
    /**
     * The ProductRequest model constructor.
     * @property {module:model/ProductRequest}
     */
    ProductRequest: ProductRequest,
    /**
     * The ProductResponse model constructor.
     * @property {module:model/ProductResponse}
     */
    ProductResponse: ProductResponse,
    /**
     * The PublisherBean model constructor.
     * @property {module:model/PublisherBean}
     */
    PublisherBean: PublisherBean,
    /**
     * The PublisherRequest model constructor.
     * @property {module:model/PublisherRequest}
     */
    PublisherRequest: PublisherRequest,
    /**
     * The PublisherResponse model constructor.
     * @property {module:model/PublisherResponse}
     */
    PublisherResponse: PublisherResponse,
    /**
     * The SettingsBean model constructor.
     * @property {module:model/SettingsBean}
     */
    SettingsBean: SettingsBean,
    /**
     * The SettingsRequest model constructor.
     * @property {module:model/SettingsRequest}
     */
    SettingsRequest: SettingsRequest,
    /**
     * The SettingsResponse model constructor.
     * @property {module:model/SettingsResponse}
     */
    SettingsResponse: SettingsResponse,
    /**
     * The SiteBean model constructor.
     * @property {module:model/SiteBean}
     */
    SiteBean: SiteBean,
    /**
     * The SiteResponse model constructor.
     * @property {module:model/SiteResponse}
     */
    SiteResponse: SiteResponse,
    /**
     * The SiteV2Request model constructor.
     * @property {module:model/SiteV2Request}
     */
    SiteV2Request: SiteV2Request,
    /**
     * The SiteV2Response model constructor.
     * @property {module:model/SiteV2Response}
     */
    SiteV2Response: SiteV2Response,
    /**
     * The StationBean model constructor.
     * @property {module:model/StationBean}
     */
    StationBean: StationBean,
    /**
     * The StationRequest model constructor.
     * @property {module:model/StationRequest}
     */
    StationRequest: StationRequest,
    /**
     * The StationResponse model constructor.
     * @property {module:model/StationResponse}
     */
    StationResponse: StationResponse,
    /**
     * The StatisticsRequest model constructor.
     * @property {module:model/StatisticsRequest}
     */
    StatisticsRequest: StatisticsRequest,
    /**
     * The StatisticsResponse model constructor.
     * @property {module:model/StatisticsResponse}
     */
    StatisticsResponse: StatisticsResponse,
    /**
     * The StripeAccountBean model constructor.
     * @property {module:model/StripeAccountBean}
     */
    StripeAccountBean: StripeAccountBean,
    /**
     * The StripeAccountEventBean model constructor.
     * @property {module:model/StripeAccountEventBean}
     */
    StripeAccountEventBean: StripeAccountEventBean,
    /**
     * The StripeAccountEventObject model constructor.
     * @property {module:model/StripeAccountEventObject}
     */
    StripeAccountEventObject: StripeAccountEventObject,
    /**
     * The StripeAccountEventRequest model constructor.
     * @property {module:model/StripeAccountEventRequest}
     */
    StripeAccountEventRequest: StripeAccountEventRequest,
    /**
     * The StripeAccountMetadataBean model constructor.
     * @property {module:model/StripeAccountMetadataBean}
     */
    StripeAccountMetadataBean: StripeAccountMetadataBean,
    /**
     * The StripeAccountRequest model constructor.
     * @property {module:model/StripeAccountRequest}
     */
    StripeAccountRequest: StripeAccountRequest,
    /**
     * The StripeAccountResponse model constructor.
     * @property {module:model/StripeAccountResponse}
     */
    StripeAccountResponse: StripeAccountResponse,
    /**
     * The StripeCouponBean model constructor.
     * @property {module:model/StripeCouponBean}
     */
    StripeCouponBean: StripeCouponBean,
    /**
     * The StripeCustomerBean model constructor.
     * @property {module:model/StripeCustomerBean}
     */
    StripeCustomerBean: StripeCustomerBean,
    /**
     * The StripeCustomerEventBean model constructor.
     * @property {module:model/StripeCustomerEventBean}
     */
    StripeCustomerEventBean: StripeCustomerEventBean,
    /**
     * The StripeCustomerEventObject model constructor.
     * @property {module:model/StripeCustomerEventObject}
     */
    StripeCustomerEventObject: StripeCustomerEventObject,
    /**
     * The StripeCustomerEventRequest model constructor.
     * @property {module:model/StripeCustomerEventRequest}
     */
    StripeCustomerEventRequest: StripeCustomerEventRequest,
    /**
     * The StripeCustomerMetadataBean model constructor.
     * @property {module:model/StripeCustomerMetadataBean}
     */
    StripeCustomerMetadataBean: StripeCustomerMetadataBean,
    /**
     * The StripeCustomerRequest model constructor.
     * @property {module:model/StripeCustomerRequest}
     */
    StripeCustomerRequest: StripeCustomerRequest,
    /**
     * The StripeCustomerResponse model constructor.
     * @property {module:model/StripeCustomerResponse}
     */
    StripeCustomerResponse: StripeCustomerResponse,
    /**
     * The StripeDiscountBean model constructor.
     * @property {module:model/StripeDiscountBean}
     */
    StripeDiscountBean: StripeDiscountBean,
    /**
     * The StripePlanBean model constructor.
     * @property {module:model/StripePlanBean}
     */
    StripePlanBean: StripePlanBean,
    /**
     * The StripeSubscriptionBean model constructor.
     * @property {module:model/StripeSubscriptionBean}
     */
    StripeSubscriptionBean: StripeSubscriptionBean,
    /**
     * The StripeSubscriptionEventBean model constructor.
     * @property {module:model/StripeSubscriptionEventBean}
     */
    StripeSubscriptionEventBean: StripeSubscriptionEventBean,
    /**
     * The StripeSubscriptionEventObject model constructor.
     * @property {module:model/StripeSubscriptionEventObject}
     */
    StripeSubscriptionEventObject: StripeSubscriptionEventObject,
    /**
     * The StripeSubscriptionEventRequest model constructor.
     * @property {module:model/StripeSubscriptionEventRequest}
     */
    StripeSubscriptionEventRequest: StripeSubscriptionEventRequest,
    /**
     * The StripeSubscriptionItemBean model constructor.
     * @property {module:model/StripeSubscriptionItemBean}
     */
    StripeSubscriptionItemBean: StripeSubscriptionItemBean,
    /**
     * The StripeSubscriptionItemMetadataBean model constructor.
     * @property {module:model/StripeSubscriptionItemMetadataBean}
     */
    StripeSubscriptionItemMetadataBean: StripeSubscriptionItemMetadataBean,
    /**
     * The StripeSubscriptionRequest model constructor.
     * @property {module:model/StripeSubscriptionRequest}
     */
    StripeSubscriptionRequest: StripeSubscriptionRequest,
    /**
     * The StripeSubscriptionResponse model constructor.
     * @property {module:model/StripeSubscriptionResponse}
     */
    StripeSubscriptionResponse: StripeSubscriptionResponse,
    /**
     * The StripeTaxIdBean model constructor.
     * @property {module:model/StripeTaxIdBean}
     */
    StripeTaxIdBean: StripeTaxIdBean,
    /**
     * The StripeTaxRateBean model constructor.
     * @property {module:model/StripeTaxRateBean}
     */
    StripeTaxRateBean: StripeTaxRateBean,
    /**
     * The SubscriberBean model constructor.
     * @property {module:model/SubscriberBean}
     */
    SubscriberBean: SubscriberBean,
    /**
     * The SubscriberRequest model constructor.
     * @property {module:model/SubscriberRequest}
     */
    SubscriberRequest: SubscriberRequest,
    /**
     * The SubscriberResponse model constructor.
     * @property {module:model/SubscriberResponse}
     */
    SubscriberResponse: SubscriberResponse,
    /**
     * The SubscriptionMetadataBean model constructor.
     * @property {module:model/SubscriptionMetadataBean}
     */
    SubscriptionMetadataBean: SubscriptionMetadataBean,
    /**
     * The TopicBean model constructor.
     * @property {module:model/TopicBean}
     */
    TopicBean: TopicBean,
    /**
     * The TopicRequest model constructor.
     * @property {module:model/TopicRequest}
     */
    TopicRequest: TopicRequest,
    /**
     * The TopicResponse model constructor.
     * @property {module:model/TopicResponse}
     */
    TopicResponse: TopicResponse,
    /**
     * The TypeformBean model constructor.
     * @property {module:model/TypeformBean}
     */
    TypeformBean: TypeformBean,
    /**
     * The TypeformRequest model constructor.
     * @property {module:model/TypeformRequest}
     */
    TypeformRequest: TypeformRequest,
    /**
     * The TypeformResponse model constructor.
     * @property {module:model/TypeformResponse}
     */
    TypeformResponse: TypeformResponse,
    /**
     * The UserBean model constructor.
     * @property {module:model/UserBean}
     */
    UserBean: UserBean,
    /**
     * The UserRequest model constructor.
     * @property {module:model/UserRequest}
     */
    UserRequest: UserRequest,
    /**
     * The UserResponse model constructor.
     * @property {module:model/UserResponse}
     */
    UserResponse: UserResponse,
    /**
     * The WorkItemV2Request model constructor.
     * @property {module:model/WorkItemV2Request}
     */
    WorkItemV2Request: WorkItemV2Request,
    /**
     * The WorkItemV2Response model constructor.
     * @property {module:model/WorkItemV2Response}
     */
    WorkItemV2Response: WorkItemV2Response,
    /**
     * The WorkV2Request model constructor.
     * @property {module:model/WorkV2Request}
     */
    WorkV2Request: WorkV2Request,
    /**
     * The WorkV2Response model constructor.
     * @property {module:model/WorkV2Response}
     */
    WorkV2Response: WorkV2Response,
    /**
     * The DefaultApi service constructor.
     * @property {module:api/DefaultApi}
     */
    DefaultApi: DefaultApi
  };

  return exports;
}));



// WEBPACK FOOTER //
// ./clientLibsDevelopment/src/index.js